/*
============================================================
 FileDataSource - Loads puzzle data from local files
------------------------------------------------------------
 Implements the data source interface for file-based puzzles
 stored in the public/data directory.
============================================================
*/

/**
 * Data source for loading puzzles from local files
 * @class FileDataSource
 */
export class FileDataSource {
  /**
   * @param {string} basePath - Base path to data files (e.g., './data/daily')
   */
  constructor(basePath) {
    this.basePath = basePath;
  }

  /**
   * Fetch puzzle data from a local JSON file
   * @async
   * @param {string} filename - The puzzle filename (without .json extension)
   * @returns {Promise<Object>} The puzzle data object
   * @throws {Error} If file not found or invalid
   */
  async fetch(filename) {
    if (!filename) {
      throw new Error("Filename is required");
    }

    const url = `${this.basePath}/${filename}.json`;
    console.log(`[FileDataSource] Fetching from: ${url}`);

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: File not found`);
      }

      const data = await response.json();

      // Validate structure
      if (!data || !data.metadata || !data.finmodel) {
        throw new Error("Invalid puzzle data structure");
      }

      return data;
    } catch (error) {
      console.error(
        `[FileDataSource] Error loading ${filename}:`,
        error.message
      );
      throw error;
    }
  }
}
